module.exports = __webpack_public_path__ + "fonts/pt_root-ui_regular.3de3ace.woff2";